import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ExitIcon } from '@ow/icons'
import { StyledUserInfoContent } from './styled/user-info'
import Avatar from '../avatar'

const UserInfo = (props) => {
  const {
    width,
    height,
    userInfo,
    backgroundColor,
    position,
    style,
    onExit,
    onUserDetail,
    otherComponent,
    className,
  } = props

  // 控制用户信息卡片的显隐状态
  const [isShowUserCard, setShowUserCard] = useState(false)

  const toToggleUserCard = (flag) => {
    setShowUserCard(flag)
  }

  return (
    <StyledUserInfoContent
      width={width}
      height={height}
      style={style}
      backgroundColor={backgroundColor}
      position={position}
      onMouseOver={() => toToggleUserCard(true)}
      onMouseOut={() => toToggleUserCard(false)}
      className={className}
    >
      {/* 显示 头像部分 */}
      <Avatar
        backgroundColor={backgroundColor}
        width={width}
        height={height}
        userInfo={userInfo}
      />
      {/* 弹出框部分 */}
      <div
        className="drop-info"
        style={{
          opacity: isShowUserCard ? '1' : '0',
          marginTop: isShowUserCard ? '0' : '6px',
          visibility: isShowUserCard ? 'visible' : 'hidden',
        }}
      >
        {/* 弹出框-用户信息 */}
        <div className="drop-user" onClick={onUserDetail}>
          <Avatar
            backgroundColor={backgroundColor}
            width={width}
            height={height}
            userInfo={userInfo}
          />
          <div className="user-text">
            <p className="name">{userInfo.name}</p>
            <p className="email">{userInfo.email}</p>
          </div>
        </div>
        {/* 其他组件 */}
        {otherComponent}
        {/* 弹出框-退出 */}
        <div className="drop-exit" onClick={onExit}>
          <ExitIcon width={18} height={18} fill="#516484" />
          <span>退出</span>
        </div>
      </div>
    </StyledUserInfoContent>
  )
}

// 默认参数
UserInfo.defaultProps = {
  width: 34,
  height: 34,
  userInfo: undefined,
  backgroundColor: undefined,
  position: 'bottom',
  onExit: undefined,
  onUserDetail: undefined,
  style: undefined,
  otherComponent: undefined,
  className: undefined,
}
// 参数类型
UserInfo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  userInfo: PropTypes.shape({}),
  position: PropTypes.oneOf(['bottom', 'right']),
  onExit: PropTypes.func,
  onUserDetail: PropTypes.func,
  style: PropTypes.shape({}),
  otherComponent: PropTypes.node,
  className: PropTypes.string,
}

export default UserInfo
